$(document).ready( function(){

	if ($('.workshop-form__popup').length > 0){

    var wrapper = $(document).find('.workshop-form__popup');
    var bookingSent = wrapper.find('.booking-sent');
    var form = wrapper.find('form');

    form.on('submit', function(evt) {

      evt.preventDefault(); 
      form.hide();
      
      var data = $(this).serialize();
      
      $.ajax({
        method: 'POST',
        data: data,
        url: $(this).attr('action'),                
        success: function(response) {
          console.log(response);
          bookingSent.show();
        },
        error: function(error){
          if (error.responseJSON){
            alert(error.responseJSON.message, 'bad');
          } else {
            alert("Unknown error", 'bad');
          }
          
          form.show();
        }
      });

    });
  }

});